// Immagini del riquadro Instagram: esportate dalla collection Firestore
// `instagram` (ott 2026), nello stesso ordine.
import post8 from '../assets/instagram/8.webp'
import post3 from '../assets/instagram/3.webp'
import post9 from '../assets/instagram/9.webp'
import post6 from '../assets/instagram/6.webp'
import post1 from '../assets/instagram/1.webp'
import post7 from '../assets/instagram/7.webp'
import post10 from '../assets/instagram/10.webp'
import post5 from '../assets/instagram/5.webp'
import post11 from '../assets/instagram/11.webp'

export const instagram = [
  { id: 'FkRJK8cpobQBWeVLcUUN', image: post8, width: 640, height: 640 },
  { id: 'P4HeDzGTuTtVdDVlSRl6', image: post3, width: 640, height: 640 },
  { id: 'YCb1MdXh2nHMbjpYMyXP', image: post9, width: 640, height: 640 },
  { id: 'av6GM4L3XzJ8B8aDeHf9', image: post6, width: 640, height: 640 },
  { id: 'daRbs7MFgMk7kKccV25D', image: post1, width: 640, height: 640 },
  { id: 'fPiciDq5xx3bsxnuBWmP', image: post7, width: 640, height: 640 },
  { id: 'sHJP11Es2ambnmt15hYv', image: post10, width: 640, height: 640 },
  { id: 'yFjH9x7D2lg1eAMNCKZ7', image: post5, width: 640, height: 640 },
  { id: 'yW1MisbiEbbRdcVvmp5w', image: post11, width: 640, height: 640 }
]
